// Note: The first file of a module here, must also register the module

import "./group-create.component";
import "./group-assignment.component";
import "./group-dashboard.component";
import "./group-info.component";
import "./group-info-dialog.component";
import "./group-list.component";
import "./group-selection-dialog.component";
import "./groups-view.component";
import "./segment-group-dialog.component";
import "./select-property-form.component";
import "./view-group-filters-dialog.component";
import "./group-status-update.component";
import "./team-assign.component";
import "./group-assign-autocomplete.component";
